(function () {
    "use strict";

    angular.module("app").component("habilFvmPerson", {
        templateUrl: "@/fvmPerson/fvm-person.html",
        bindings: {
            person: "=",
            request: "="
        },
        controller: FvmPersonController,
        controllerAs: "vm",
    });

    FvmPersonController.$inject = ["$rootScope", "controllerDecorator", "enumService", "userFunctions", "pscRequestLetterApi", "base64Service", "$document",];
    function FvmPersonController($rootScope, controllerDecorator, enumService, userFunctions, pscRequestLetterApi, base64Service, $document) {
        const personActionCodes = enumService.PersonActionCodes;
        const personStatusCodes = enumService.PersonStatusCodes;
        const fvmInitialActions = enumService.FvmInitialActions;
        const ivmStatusCodes = enumService.IvmStatusCodes;
        const screeningServices = enumService.ScreeningServices;

        const userIsSo = userFunctions.currentUserHasRole("VO-SO");
        const userIsBoardMember = userFunctions.currentUserHasRole("VO-EX");
        const userReferenceNbr = userFunctions.currentUserReferenceNbr();
        const userWorksForPartnerFODECO = userFunctions.userWorksForPartner(screeningServices.FODECO);

        const vm = Object.assign(this, {
            GetJobFunction,
            GetBirthCountry,
            GetCountries,
            NationalityCountryNotBelgium,
            GetLanguage,
            GetNoAcknowledgmentChosenFor,
            OpenIvm,
            GetOpenIvmText,
            CanShowOpenIvmButton,
            CanShowRemark,
            IsAllowedToStartRefusalLetter,
            IsAllowedToStartLimitationLetter,
            StartRefusalLetter,
            StartLimitationLetter,
            isPscAdministrativeRefusalAllowed,
            communicatePscAdministrativeRefusal,
            isAllowedToSendTemporaryNoAcknowledgementDocument,
            sendTemporaryNoAcknowledgementDocument,
            uploadTemporaryNoAcknowledgementDocument,
        });
        controllerDecorator.Decorate(vm, ["navigation", "dialog"]);

        vm.$onInit = initialize;

        const model = { TemporaryNoAcknowledgementDocument: null };
        vm.model = model;

        function initialize() {
            vm.Countries = $rootScope.codeCountries;
            vm.Languages = $rootScope.codeLanguages;
            vm.JobFunctions = $rootScope.codeJobFunctions;
            vm.VMTypes = $rootScope.codeVMTypes;
        }

        function GetJobFunction() {
            if (!vm.person)
                return vm.getTranslation("Label_NotKnown");

            if (vm.person.JobFunctionCode) {
                const code = vm.JobFunctions.find(c => c.Key === vm.person.JobFunctionCode);
                return code ? code.Value : vm.getTranslation("Label_NotKnown");
            }
            else {
                return vm.getTranslation("Label_NotKnown");
            }
        }

        function GetBirthCountry() {
            if (!vm.person)
                return vm.getTranslation("Label_NotKnown");

            if (vm.person.BirthCountryCode) {
                const code = vm.Countries.find(c => c.Key === vm.person.BirthCountryCode);
                return code ? code.Value : vm.getTranslation("Label_NotKnown");
            }
            else {
                return vm.getTranslation("Label_NotKnown");
            }
        }

        function GetCountries() {
            if (!vm.person ||
                !vm.person.Nationalities ||
                vm.person.Nationalities.length == 0)
                return "";

            return vm.person.Nationalities.map(x => `${vm.Countries.find(c => c.Key === x.NationalityCode).Value}`).join(" / ");
        }

        function NationalityCountryNotBelgium() {
            if (!vm.person ||
                !vm.person.Nationalities ||
                vm.person.Nationalities.length == 0 ||
                !vm.person.Action ||
                vm.person.Action.Code != "StartIVM")
                return false;

            return !vm.person.Nationalities.some(n => n.NationalityCode == "BE");
        }

        function GetLanguage() {
            if (!vm.person || !vm.person.LanguageCode)
                return "";

            const code = vm.Languages.find(c => c.Key === vm.person.LanguageCode);

            return code ? code.Value : "";
        }

        function CanShowOpenIvmButton() {
            if (!vm.person ||
                !vm.request ||
                userWorksForPartnerFODECO ||
                (userIsBoardMember && !userIsSo))
                return false;

            return vm.person.Action && vm.person.IsLinkedToIvm && vm.person.IVMLink && vm.person.IVMStatus;
        }

        function GetNoAcknowledgmentChosenFor(person) {
            if (!person.NoAcknowledgementForClearanceCodes) return;

            return JSON.parse(person.NoAcknowledgementForClearanceCodes);
        }

        function isSoPscRequest() {
            const referenceMatchesWithUser = vm.person.ReferenceNbr === userReferenceNbr;
            const hasAction = vm.person.Action !== null;
            const actionStartIVM = vm.person.Action.Code === personActionCodes.StartIVM;
            const linkedToIvm = vm.person.IsLinkedToIvm;
            const hasIVMLink = vm.person.IVMLink !== null;
            const pscWithInvolved = Number.parseInt(vm.person.IVMStatus) == ivmStatusCodes.WithInvolved;

            return userIsSo && referenceMatchesWithUser && hasAction && actionStartIVM && linkedToIvm && hasIVMLink && pscWithInvolved;
        }

        function GetOpenIvmText() {
            if (isSoPscRequest(vm.person)) {
                return vm.getTranslation("Person_InitPhase1_Complete_Self");
            }

            return vm.getTranslation("Organisation_IVM_OpenPersonalFile");
        }

        function OpenIvm() {
            const referenceMatchesWithUser = vm.person.ReferenceNbr === userReferenceNbr;
            const pscWithInvolved = Number.parseInt(vm.person.IVMStatus) == ivmStatusCodes.WithInvolved;

            if (userIsSo && referenceMatchesWithUser && pscWithInvolved) {
                vm.Navigator.FillInIvm(vm.person.IVMLink);
            } else {
                vm.Navigator.ReviewIvm(vm.person.IVMLink, Number.parseInt(vm.person.IVMStatus));
            }
        }

        function CanShowRemark() {
            if (!vm.person || !vm.request)
                return false;

            // Show the remark if: the FSC is a change, always if started before 1/02 or if the person is removed (on or after 1/02)
            return vm.person.Remark &&
                (vm.request.InitialAction === fvmInitialActions.Change ||
                vm.request.CanSecurityOfficerSelectActions ||
                 (!vm.request.CanSecurityOfficerSelectActions && vm.person.StatusCode == personStatusCodes.UserBlock));
        }

        function IsAllowedToStartRefusalLetter() {
            if (!vm.person || vm.person.ResultCode !== 0)
                return false;

            const motivationLetterAllowDraftRole = "NVO-MotivationLetterAllowDraft";

            return Number.parseInt(vm.person.IVMStatus) == ivmStatusCodes.Refused && userFunctions.currentUserHasRole(motivationLetterAllowDraftRole);
        }

        function IsAllowedToStartLimitationLetter() {
            if (!vm.person || vm.person.ResultCode !== 0)
                return false;

            const motivationLetterAllowDraftRole = "NVO-MotivationLetterAllowDraft";

            const allowedStates = [
                ivmStatusCodes.AcceptedWithLimitation,
                ivmStatusCodes.AcceptedWithAlternativeMeasure
            ];

            return allowedStates.includes(Number.parseInt(vm.person.IVMStatus)) && userFunctions.currentUserHasRole(motivationLetterAllowDraftRole);
        }

        function StartRefusalLetter() {
            if (!IsAllowedToStartRefusalLetter())
                return;

            vm.SetLoadingState(true);

            pscRequestLetterApi.StartRefusalLetter(
                { PublicId: vm.person.IVMLink },
                (result) => {
                    if (!CheckResultReceived(result)) {
                        vm.ShowError(result);
                        return;
                    }

                    vm.Navigator.ReviewIvm(vm.person.IVMLink, Number.parseInt(vm.person.IVMStatus));
                },
                vm.ShowError,
                () => vm.SetLoadingState(false));
        }

        function StartLimitationLetter() {
            if (!IsAllowedToStartLimitationLetter())
                return;

            vm.SetLoadingState(true);

            pscRequestLetterApi.StartLimitationLetter(
                { PublicId: vm.person.IVMLink },
                (result) => {
                    if (!CheckResultReceived(result)) {
                        vm.ShowError(result);
                        return;
                    }

                    vm.Navigator.ReviewIvm(vm.person.IVMLink, Number.parseInt(vm.person.IVMStatus));
                },
                vm.ShowError,
                () => vm.SetLoadingState(false));
        }

        function isPscAdministrativeRefusalAllowed() {
            if (!vm.person ||
                !vm.person.IsLinkedToIvm ||
                !vm.person.IVMLink ||
                !Number.parseInt(vm.person.IVMStatus))
                return false;

            const allowedRole = "NVO-FVM";

            const allowedStates = [
                ivmStatusCodes.SentBackByCOL,
                ivmStatusCodes.Reported,
                ivmStatusCodes.Accepted,
            ];

            return allowedStates.includes(Number.parseInt(vm.person.IVMStatus)) && userFunctions.currentUserHasRole(allowedRole);
        }

        function communicatePscAdministrativeRefusal() {
            if (!isPscAdministrativeRefusalAllowed())
                return;

            const $dialogScope = $rootScope.$new(true);

            $dialogScope.Motivation = vm.getTranslation("PscAdministrativeRefusal_DefaultReason");

            const sendButtonId = "sendButton";
            const dialogOptions = {
                templateHtml:
                    `<div>
                        <div class="row">
                            <label for="txtReason">${vm.getTranslation("PscAdministrativeRefusal_Reason")} *</label>
                            <textarea
                                id="txtReason"
                                rows="5"
                                class="form-control no-resize"
                                ng-model-options="{ updateOn: 'default blur', debounce: { default: 250, blur: 0 } }"
                                ng-model="Motivation"
                                required>
                            </textarea>
                        </div>
                    </div>`,
                scope: $dialogScope,
                title: vm.getTranslation("PscAdministrativeRefusal"),
                size: "large",
                onEscape: true,
                closeButton: true,
                buttons: {
                    sendEmail: {
                        id: sendButtonId,
                        label: `<i class="fa fa-send"></i> ${vm.getTranslation("SendEmail")}`,
                        className: "btn-primary",
                        callback: onSubmit,
                    },
                    cancel: {
                        label: vm.getTranslation("Button_Cancel"),
                        className: "btn-default"
                    }
                }
            };

            vm.Dialog.Custom(dialogOptions);

            function onSubmit() {
                vm.SetLoadingState(true);

                const payLoad = {
                    PublicId: vm.person.IVMLink,
                    Reason: $dialogScope.Motivation,
                };

                vm.Api.SendInvestigationImpossibleEmail(
                    payLoad,
                    (result) => {
                        if (!CheckResultReceived(result)) {
                            vm.ShowError(result);
                            return;
                        }

                        vm.person.IVMStatus = ivmStatusCodes.AdministrativeRefusalCommunicated;
                    },
                    vm.ShowError,
                    () => vm.SetLoadingState(false));
            }

            $dialogScope.$watchGroup(["Motivation"], () => {
                const shouldDisableButton = !$dialogScope.Motivation;

                const sendButton = angular.element($document[0].getElementById(sendButtonId));
                sendButton.toggleClass("disabled", shouldDisableButton);
                sendButton.attr("disabled", shouldDisableButton);
            });
        }

        function isAllowedToSendTemporaryNoAcknowledgementDocument() {
            if (!vm.person ||
                !vm.person.IsLinkedToIvm ||
                !vm.person.IVMLink ||
                !vm.person.IVMStatus)
                return false;

            if (vm.person.HasSignedTemporaryNoAcknowledgementDocument)
                return false;

            if (Number.parseInt(vm.person.IVMStatus) !== ivmStatusCodes.AcceptedForeign)
                return false;

            const allowedRole = "NVO-FVM";
            return userFunctions.currentUserHasRole(allowedRole);
        }

        function sendTemporaryNoAcknowledgementDocument() {
            if (!isAllowedToSendTemporaryNoAcknowledgementDocument())
                return;

            const $dialogScope = $rootScope.$new(true);

            $dialogScope.Motivation = "";

            const sendButtonId = "sendButton";
            const dialogOptions = {
                templateHtml:
                    `<div>
                        <div class="row">
                            <label for="txtReason">${vm.getTranslation("SelectNoAcknowledgement_Motivation_Title")}: *</label>
                            <textarea
                                id="txtReason"
                                rows="5"
                                class="form-control no-resize"
                                ng-model-options="{ updateOn: 'default blur', debounce: { default: 250, blur: 0 } }"
                                ng-model="Motivation"
                                required>>
                            </textarea>
                        </div>
                    </div>`,
                scope: $dialogScope,
                title: vm.getTranslation("SendTemporaryNoAcknowledgementDocument"),
                size: "large",
                onEscape: true,
                closeButton: true,
                buttons: {
                    sendEmail: {
                        id: sendButtonId,
                        label: `<i class="fa fa-send"></i> ${vm.getTranslation("SendEmail")}`,
                        className: "btn-primary",
                        callback: onSubmit,
                    },
                    uploadSignedDocument: {
                        label: `<i class="fa fa-upload"></i> ${vm.getTranslation("UploadSignedNoAcknowledgmentDocument")}`,
                        className: "btn-primary-alt",
                        callback: () => {
                            const fileInput = angular.element(`<input type="file" accept=".pdf" style="display:none;" />`);

                            fileInput.on('change', function (event) {
                                // event.target is the raw DOM element
                                if (event.target.files && event.target.files.length > 0) {
                                    uploadAttachment(event.target);
                                }
                            });

                            $document.find('body').append(fileInput);

                            fileInput[0].click();

                            return false;
                        }
                    },
                    cancel: {
                        label: vm.getTranslation("Button_Cancel"),
                        className: "btn-default"
                    }
                }
            };

            vm.Dialog.Custom(dialogOptions);

            function onSubmit() {
                vm.SetLoadingState(true);

                const payLoad = {
                    RequestId: vm.request.PublicId,
                    PersonId: vm.person.PublicId,
                    Motivation: $dialogScope.Motivation,
                };

                vm.Api.SendInvitationToSignTemporaryNoAcknowledgementDocument(
                    payLoad,
                    (result) => {
                        if (!CheckResultReceived(result)) {
                            vm.ShowError(result);
                            return;
                        }

                        vm.Dialog.Alert(vm.getTranslation("NoAcknowledgementInvitationWasSent"));
                    },
                    vm.ShowError,
                    () => vm.SetLoadingState(false)
                );
            }

            function uploadAttachment(fileInput) {
                const reader = new FileReader();

                reader.onload = function () {
                    const content = base64Service.convertArrayBufferToBase64String(reader.result);
                    const name = fileInput.files[0].name;
                    const attachment = { Name: name, Content: content, TypeCode: "503", Uploaded: new Date() };

                    model.TemporaryNoAcknowledgementDocument = attachment;

                    uploadTemporaryNoAcknowledgementDocument();

                    vm.Dialog.CloseAll();
                };

                reader.readAsArrayBuffer(fileInput.files[0]);
            }

            $dialogScope.$watchGroup(["Motivation"], () => {
                const shouldDisableButton = !$dialogScope.Motivation;

                const sendButton = angular.element($document[0].getElementById(sendButtonId));
                sendButton.toggleClass("disabled", shouldDisableButton);
                sendButton.attr("disabled", shouldDisableButton);
            });
        }

        function uploadTemporaryNoAcknowledgementDocument() {
            vm.SetLoadingState(true);

            const payLoad = {
                RequestId: vm.request.PublicId,
                PersonId: vm.person.PublicId,
                TemporaryNoAcknowledgementDocument: model.TemporaryNoAcknowledgementDocument,
            };

            vm.Api.UploadTemporaryNoAcknowledgementDocument(
                payLoad,
                (result) => {
                    if (!CheckResultReceived(result)) {
                        vm.ShowError(result);
                        return;
                    }

                    vm.person.HasSignedTemporaryNoAcknowledgementDocument = result.data;

                    vm.ShowSuccess(vm.getTranslation("Actionbar_YourChangesHaveBeenSavedSuccessfully"));
                },
                vm.ShowError,
                () => vm.SetLoadingState(false)
            );
        }
    }
})();